import { Routes, Route } from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import ToastContainer from "./components/Toast";
import { useAuthStore } from "./store/auth";
import { fetchCurrentUser } from "./api/client";

import HomePage from "./pages/HomePage";
import StockRouter from "./pages/TickerPage/StockRouter";
const ChartsPage = React.lazy(() => import("./pages/ChartsPage"));

export default function App() {
  const { setUser, setLoading } = useAuthStore();

  useEffect(() => {
    fetchCurrentUser()
      .then((user) => setUser(user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [setUser, setLoading]);

  return (
    <>
      <Suspense fallback={<div className="flex h-screen items-center justify-center bg-gray-50 text-gray-400"><p>Loading...</p></div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/charts" element={<ChartsPage />} />
          <Route path="/stocks/*" element={<StockRouter />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </>
  );
}
